import { defineComponent as _defineComponent } from 'vue'
import NavigationBar from "@/components/shared/NavigationBar.vue";
import { ILineInfo } from "@/domain/entities/lineInfo";
import useGetBusStopEndTime from "@/use/useGetBusStopEndTime";
import useGetBusStopStartTime from "@/use/useGetBusStopStartTime";
import useGetLineRouteName from "@/use/useGetLineRouteName";
import { computed, PropType, ref } from "vue";
import TimeTable from "./TimeTable.vue";
import InlineSvg from "vue-inline-svg";
import ScrollTopControl from "@/components/shared/ScrollTopControl.vue";
import { IBusStopData } from "@/domain/entities/busStop";


const __default__ = {
  name: "LineInfoDetailExtended",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  lineInfo: {
    type: Object as PropType<ILineInfo>,
    required: true,
  },
  isInsideShuttle: {
    type: Boolean,
    default: false,
  },
  busStops: {
    type: Array as PropType<IBusStopData[]>,
    default: () => [],
  },
  departureTimes: {
    type: Array as PropType<Array<string>>,
    default: () => [],
  },
  nextBusStopChangeDateTime: {
    type: String,
  },
},
  emits: ["onClickClose"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const scrollContainer = ref<HTMLElement>();

const title = computed(() => {
  const { lineTypeCode, routeName, lineNum } = props.lineInfo;
  return `${useGetLineRouteName(lineTypeCode, routeName, lineNum)} 상세`;
});

const emitOnClickClose = () => {
  emit("onClickClose");
};

/** 사내셔틀의 운행시각 */
const availableTimeStr = computed(() => {
  const startTime = useGetBusStopStartTime(props.lineInfo);
  const endTime = useGetBusStopEndTime(props.lineInfo);
  return `${startTime}~${endTime}`;
});

/** 기점 정류장 */
const firstBusStop = computed(() => {
  if (!props.busStops.length) {
    return props.lineInfo.turns[0].firstStop;
  }

  return props.busStops[0];
});

/** 종점 정류장 */
const lastBusStop = computed(() => {
  if (!props.busStops.length) {
    return props.lineInfo.turns[0].lastStop;
  }

  return props.busStops[props.busStops.length - 1];
});

// 기점출발시각
const departureTimesStr = computed(() => props.departureTimes.join(" / "));

// 정류장 목록
const busStopNames = computed(() => {
  return props.busStops.map((busStop) => busStop.name).join(" - ");
});

const __returned__ = { props, emit, scrollContainer, title, emitOnClickClose, availableTimeStr, firstBusStop, lastBusStop, departureTimesStr, busStopNames, NavigationBar, TimeTable, get InlineSvg() { return InlineSvg }, ScrollTopControl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})